import { UtilsAction } from './utils.actions';

export class UtilsState {
    timer: string;
    datetime: string;
    pending: boolean;
    error: null;
    debugModeEnabled: boolean;
    debugModeCounter: number;
}

export const initialState: UtilsState = {
    timer: null,
    datetime: null,
    pending: false,
    error: null,
    debugModeCounter: 0,
    debugModeEnabled: false
}


export function UtilsReducer(state: UtilsState = initialState, { type, payload }){

    switch (type) {

        case UtilsAction.getTimer:
            return {...state, ...{ pending: true, error: null }};

        case UtilsAction.getTimerSuccess:
            return {...state, ...{ timer: payload, pending: false, error: null }};
        
        case UtilsAction.getDateTimeSuccess:
            return {...state, ...{ datetime: payload, pending: false, error: null }};

        case UtilsAction.getTimerError:
            return {...state, ...{ pending: false, error: payload }};

        case UtilsAction.enableDebugMode:
            const counter =  state.debugModeCounter + 1;
            return {...state, ...{ debugModeCounter: counter, debugModeEnabled: counter % 3 == 0 }};
            
        default:
            return state;
    }
};
